var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"card shadow"},[_c('div',{staticClass:"card-header"},[_c('h6',[_vm._v("Redirect")])]),_c('div',{staticClass:"card-body text-center"},[_vm._v(" You are being redirected, please wait. ")])])])
}]

export { render, staticRenderFns }